export interface DealDebtSchedule {
	guid: string;
	dealGuid: string;
	originalLoanAmount: number | null;
	presentBalance: number | null;
	interestRate: number | null;
	monthlyPayment: number | null;
	maturityDate: string | null;
	collateralSecurityType: CollateralSecurityTypes | null;
	dealFacilityId: number | null;
	isRefinance: boolean | null;
	amortization: number | null;
	facilityType: FacilityTypes | null;
	lenderType: LenderTypes | null;
	isTermLoan: boolean;
	isRevolver: boolean;
	notes: string | null;
}

export type FacilityTypes = keyof typeof FacilityTypeMap;

export const FacilityTypeMap = {
	Unknown: 'Unknown / TBD',
	Term_Loan: 'Term Loan',
	Revolver: 'Revolver',
	Letter_of_Credit: 'Letter of Credit',
	Line_of_Credit: 'Line of Credit',
	Bridge_Facility: 'Bridge Facility',
	Syndicated_Facility: 'Syndicated Facility',
	EquipmentLease: 'Equipment Lease',
	CapitalLease: 'Capital Lease',
	OperatingLease: 'Operating Lease',
	Bond: 'Bond',
	Warehouse: 'Warehouse',
	Factor: 'Factor',
	PurchaseOrderFinancing: 'Purchase Order Financing',
};

export type LenderTypes = keyof typeof LenderTypeMap;

export const LenderTypeMap = {
	Assessment: 'Asset-Based',
	Bank: 'Bank - Conventional',
	EquipmentBased: 'Equipment-Based',
	Factoring: 'Factoring',
	NonBank: 'Non-Bank / Direct Lender',
	Other: 'Individual / Other',
	Sba: 'SBA',
	SellerFinancing: 'Seller Financing',
	Usda: 'USDA',
	Unknown: 'Unknown',
};

export type CollateralSecurityTypes = keyof typeof CollateralSecurityTypeMap;

export const CollateralSecurityTypeMap = {
	SecuredFirstLien: 'Secured - First Lien All Business Assets',
	Mezzanine: 'Mezzanine',
	SecondLien: 'Second Lien',
	SecondLienRealEstate: 'Second Lien - Owner Occupied Real Estate',
	SecuredAr: 'Secured - A/R',
	SecuredArPlusInventory: 'Secured - A/R + Inventory',
	SecuredCash: 'Secured - Cash',
	SecuredEquipment: 'Secured - Machinery & Equipment',
	SecuredFixedWingAircraft: 'Secured - Fixed Wing Aircraft',
	SecuredGeneral: 'Secured - General / 1st Lien',
	SecuredHelicopters: 'Secured - Helicopters',
	SecuredInventory: 'Secured - Inventory',
	SecuredIp: 'Secured - Intellectual Property',
	SecuredMarine: 'Secured - Marine Vessels',
	SecuredOther: 'Secured - Other',
	SecuredRealEstate: 'Secured - Owner Occupied Real Estate',
	SecuredRoyalty: 'Secured - Royalty/Licensing',
	SecuredSecondLien: 'Secured - Second Lien All Business Assets',
	SecuredSecurities: 'Secured - Marketable Securities',
	SecuredVehicles: 'Secured - Vehicles',
	Unsecured: 'Unsecured',
};

export type MaturityQuarterTypes = keyof typeof MaturityQuarterTypeMap;
export const MaturityQuarterTypeMap = {
	Q1: 'Q1',
	Q2: 'Q2',
	Q3: 'Q3',
	Q4: 'Q4',
};
